import styled from "styled-components";
import { TextField } from "@mui/material";

const BaseTextField = styled(TextField)`
  .MuiInputBase-root {
    background-color: ${(props) => props.theme.color.background.light};
  }
  width: 100%;
  border-radius: 4px;
  .MuiInputBase-input {
    color: ${(props) => props.theme.color.text.primary};
    &::placeholder {
      color: ${(props) => props.theme.color.text.caption};
      font-size: ${(props) => props.theme.font.size.disclaimer};
      font-weight: 400;
    }
  }
`;

const MultilineTextField = () => {
  return <BaseTextField multiline maxRows={3} />;
};

const Title = styled.label`
  display: flex;
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const SubTitle = styled.label`
  text-align: start;
  font-size: ${(props) => props.theme.font.size.secondary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
  display: block;
  margin-bottom: 16px;
  margin-top: 24px;
`;

const Button = styled.button`
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  width: 100%;
  text-overflow: ellipsis;
  max-lines: 1;
  height: ${(props) => props.theme.coloredButtonHeight.primary};
  text-align: center;
  text-decoration: none;
  border: none;
  line-height: ${(props) => props.theme.coloredButtonHeight.primary};
  margin-top: 16px;
  color: ${(props) => props.theme.color.text.secondary};
  background-color: ${(props) => props.theme.color.accent};
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;
export { BaseTextField, MultilineTextField, Title, SubTitle, Button };
